import {
  View,
  Text,
  SafeAreaView,
  StatusBar,
  Platform,
  I18nManager,
} from "react-native";
import React from "react";
import HeaderProfileIcon from "../header/HeaderProfileIcon";
import MyText from "../custom/MyText";
import Wallet from "./Wallet";
import SectionButton from "./SectionButton";
import translate from "../../functions/translate";
import Dropdown from "../custom/Dropdown";
import Cookies from "universal-cookie";
import { danger, primary } from "../../colors";
import PersonIcon from "../../assets/svg/PersonIcon";
import SupportIcon from "../../assets/svg/SupportIcon";
import InfoIcon from "../../assets/svg/InfoIcon";
import LogoutIcon from "../../assets/svg/LogoutIcon";
import { useDispatch, useSelector } from "react-redux";
import { addToken } from "../../redux/main/mainAction";
import { removeData } from "../../functions/db/db";
import { deleteToken } from "../../api/token";
import { useState } from "react";
import { useEffect } from "react";
import { storeStringData } from "../../functions/db/db";
import * as Updates from "expo-updates";
import { unsetUserInformation } from "../../redux/user/userAction";
import { useNavigation } from "@react-navigation/native";
import BabyIcon from "../../assets/svg/BabyIcon";
import { EvilIcons } from '@expo/vector-icons';
const cookies = new Cookies();

export default function LoggedIn() {
  const dispatch = useDispatch();
  const [items, setItems] = useState([
    { id: 1, name: "فارسی" },
    { id: 2, name: "English" },
  ]);
  const main = useSelector((store) => store.main);
  let currentSelected = main.rtl ? 1 : 2;
  const [selected, setSelected] = useState({ selected: main.rtl ? 1 : 2 });
  const navigation = useNavigation();
  useEffect(() => {
    if (currentSelected !== selected.selected) {
      currentSelected = selected.selected;

      if (Platform.OS === "web") {
        if (selected.selected === 2) {
          cookies.set("language", "english");
          //setTimeout(() => location.reload(), 500);
          location.reload();
        } else {
          cookies.set("language", "persian");
          location.reload();
        }
        return;
      }
      if (selected.selected === 2) {
        I18nManager.forceRTL(false);
        I18nManager.allowRTL(false);
        storeStringData("languageSet", "english");
        Updates.reloadAsync();
      } else {
        I18nManager.forceRTL(true);
        I18nManager.allowRTL(true);
        storeStringData("languageSet", "english");
        //   setTimeout(() => dispatch(setConfirmLanguageModal()), 700);
        Updates.reloadAsync();
      }
    }
  }, [selected]);
  const logout = () => {
    deleteToken();
    if (Platform.OS === "web") {
      const cookies = new Cookies();
      cookies.set("token", null);
      dispatch(addToken(null));
    } else {
      removeData("token");
      dispatch(addToken(null));
    }
    dispatch(unsetUserInformation());
  };
  const user = useSelector((store) => store.user);

  return (
    <SafeAreaView
      style={{
        flex: 1,
        paddingTop: Platform.OS === "android" ? StatusBar.currentHeight : 0,
      }}
      dir={cookies.get("language") === "english" ? "ltr" : "rtl"}
    >
      <View style={{ padding: 10 }}>
        <View style={{ flexDirection: "row", alignItems: "center" }}>
          <HeaderProfileIcon />
          <MyText
            style={{
              marginHorizontal: 10,
              fontSize: 18,
              fontWeight: "bold",
              color: primary,
            }}
          >
            {`${user.information.name}`}
          </MyText>
        </View>
        <View style={{ marginTop: 10 }}>
          <Wallet />
        </View>
        <View>
          {/* <SectionButton
            onPress={() => navigation.navigate('Profile')}
            name={translate("profile")}
            icon={PersonIcon}
          /> */}
          <SectionButton
            onPress={() => navigation.navigate("ChildrenDetail")}
            name={translate("my children")}
            icon={BabyIcon}
          />
          <SectionButton
            onPress={() =>
              navigation.navigate("TestNavigator", {
                screen: "TestArchive",
                initial: false,
              })
            }
            name={translate("test archive")}
            icon={() => <EvilIcons name="archive" size={24} color="black" />}
          />
          <SectionButton
            onPress={() => navigation.navigate("Support")}
            name={translate("support")}
            icon={SupportIcon}
          />
          <SectionButton
            onPress={() => navigation.navigate("AboutUs")}
            name={translate("about")}
            icon={InfoIcon}
          />
        </View>
        <View>
          <SectionButton
            onPress={logout}
            name={translate("logout")}
            icon={LogoutIcon}
            iconPlaceStyle={{ backgroundColor: danger, borderColor: danger }}
            textStyle={{ color: danger }}
            style={{ borderBottomColor: danger }}
          />
        </View>
        <View style={{ marginTop: 30 }}>
          <MyText style={{ marginBottom: 5 }}>
            {translate("app language")}
          </MyText>
          <Dropdown
            items={items}
            setSelected={setSelected}
            selected={selected.selected}
          />
        </View>
      </View>
    </SafeAreaView>
  );
}
